<div class="icon-container">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 7V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V7C20 5.34315 18.6569 4 17 4H7C5.34315 4 4 5.34315 4 7Z"
      stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <rect id="expandable-dot" x="10" y="10" width="4" height="4" rx="2" fill="white" />
  </svg>
</div>
